import { render, staticRenderFns } from "./JoinMeeting.vue?vue&type=template&id=12a6c047&scoped=true"
import script from "./JoinMeeting.vue?vue&type=script&lang=ts"
export * from "./JoinMeeting.vue?vue&type=script&lang=ts"
import style0 from "./JoinMeeting.vue?vue&type=style&index=0&id=12a6c047&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a6c047",
  null
  
)

export default component.exports